import {ChangeDetectionStrategy, Component, ElementRef, Input} from '@angular/core';
import {Modifier} from '@popperjs/core';
import {DropdownMenuComponent} from '../../dropdown-menu';
import {DropdownMenuItem} from '../../dropdown-menu/dropdown-menu-item';
import {createPopperReferenceWideModifier} from '../../popper-utils/modifiers/popper-reference-wide';
import {PopperOptions} from '../../popper-utils/popper-options';

@Component({
    selector: 'ul[dropdown-menu]',
    templateUrl: '../../dropdown-menu/dropdown-menu.component.html',
    styleUrls: ['../../dropdown-menu/dropdown-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectInputMenuComponent extends DropdownMenuComponent {

    @Input()
    public override targetElement: ElementRef;

    @Input()
    public override menuItems: DropdownMenuItem[];

    protected override initPopper(popperOptions: PopperOptions = {}): void {
        super.initPopper({
            placement: 'bottom-start',
            ...popperOptions
        });
    }

    protected override getPopperModifiers(): Array<Modifier<any, any>> {
        return [
            ...super.getPopperModifiers(),
            createPopperReferenceWideModifier()
        ];
    }
}
